import { helper } from "src/utils/helper";

class SonucIzlemeMuracaatListeRequest {
    baslangicTarihi: string = helper.startDate();
    bitisTarihi: string = helper.endDate();
    kurumGrubu: number = null;
    kurumGrubuId: number = null;
    kurumIds: string = "";
    servisIds: Array<number> = [];
    testGrubu: number = null;
    onayaHazirKayitlar: number = null;
    durum?: number;
    indirilmisRaporlar: number = null;
    entProtokolno: string = "";
};
export default SonucIzlemeMuracaatListeRequest;